<div class="loading-overlay">
  <div class="loading-indicator">
    <div class="loading-spinner"></div>
    <span class="loading-text">{{ message }}</span>
  </div>
</div>
